import AuthenticationService from "@services/AuthenticationService";
import getRoutePath from "../../../routes/getRoutePath";

const Logout = () => {
  AuthenticationService.logout();

  window.location = getRoutePath("/login");

  return null;
};

export default Logout;
